'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isToday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isToday.js
// module id = 559
// module chunks = 0